import { CompanyCreatePage } from '@pages/company';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Создание компании', 'Создание новой компании');
}

export default CompanyCreatePage;
